import get from "lodash/get";
import {
  LAMBDATEST_CLEAR_PLAYWRIGHT_TRACE_LOGS,
  LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_FAILED,
  LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_LOADING,
  LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_SUCCESS
} from "../../actionTypeConstants/ml2.0/PlaywrightTraceLogs";

const initialState = {
  loading: true,
  viewURL: "",
  downloadURL: ""
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        viewURL: "",
        downloadURL: ""
      };
    }

    case LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_SUCCESS: {
      const viewURL = get(
        action,
        ["result", "data", "data", "traceViewerUrl"],
        false
      );
      const downloadURL = get(
        action,
        ["result", "data", "data", "presignedUrl"],
        ""
      );

      return {
        ...state,
        loading: false,
        viewURL: viewURL,
        downloadURL: downloadURL
      };
    }

    case LAMBDATEST_PLAYWRIGHT_TRACE_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        viewURL: "",
        downloadURL: ""
      };
    }

    case LAMBDATEST_CLEAR_PLAYWRIGHT_TRACE_LOGS: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}